<script lang="ts">
  import { Eye } from "lucide-svelte";
  interface Props {
    todayPv: number;
    growthRate: number;
    t: (path: string) => string;
  }
  let { todayPv, growthRate, t }: Props = $props();
</script>

<div class="rounded-xl border bg-card p-4 shadow-sm flex flex-col justify-between">
  <div class="flex items-center justify-between">
    <p class="text-xs font-medium text-muted-foreground uppercase tracking-wider">{t('dashboard.kpi.today_pv')}</p>
    <Eye class="h-4 w-4 text-primary" />
  </div>
  <div class="mt-2">
    <span class="text-3xl font-extrabold tracking-tight">{todayPv}</span>
    <span class="text-xs text-muted-foreground ml-1">{t('dashboard.kpi.pv_unit')}</span>
  </div>
  <div class="mt-3 flex items-center justify-between text-xs text-muted-foreground border-t pt-2">
    <span>{t('dashboard.kpi.pv_growth_vs_yesterday')}</span>
    <span class="{growthRate >= 0 ? 'text-emerald-600' : 'text-rose-600'} font-semibold">
      {growthRate >= 0 ? '+' : ''}{growthRate}%
    </span>
  </div>
</div>